<template>
  <div
    :data-tint="tint"
    class="relative overflow-hidden rounded-lg text-gray-800 dark:text-white"
    :role="role"
    tabindex="-1"
    :style="
      primaryColor ? { '--callout-gradient-start': primaryColor } : undefined
    "
    :class="[
      compact ? 'p-3' : 'p-4',
      inline ? 'inline-block w-fit' : null,
      primaryColor
        ? 'bg-[linear-gradient(to_right,var(--callout-gradient-start)_50%,var(--color-primary-300)_75%)] dark:bg-[linear-gradient(to_right,var(--callout-gradient-start)_50%,color-mix(in_oklab,var(--color-primary-900)_40%,transparent)_75%)]'
        : watermarkIcon
          ? 'bg-linear-to-r from-primary-200 via-primary-200 via-65% to-primary-300 dark:from-primary-800/10 dark:via-primary-800/10 dark:via-65% dark:to-primary-900/40'
          : 'bg-primary-200 dark:bg-primary-800/10'
    ]"
  >
    <div
      v-if="watermarkIcon"
      class="callout-watermark-glow absolute inset-y-0 right-6 flex items-center text-primary-400 dark:text-primary-800"
      :class="{
        'text-6xl': !compact,
        'text-5xl': compact
      }"
    >
      <FontAwesomeIcon :icon="watermarkIcon" />
    </div>
    <div
      class="flex"
      :class="{
        'pr-24': watermarkIcon && !compact,
        'pr-20': watermarkIcon && compact
      }"
    >
      <div v-if="icon" class="shrink-0">
        <FontAwesomeIcon :icon="icon" />
      </div>
      <div
        class="ms-3 flex flex-col"
        :class="{
          'gap-2': !compact,
          'gap-1': compact
        }"
      >
        <h3 v-if="title?.length" class="font-semibold capitalize-first">
          {{ title }}
        </h3>
        <div
          v-if="description?.length"
          class="text-sm font-semibold text-gray-600 capitalize-first dark:text-neutral-400"
          v-html="description"
        ></div>
        <slot />
        <div v-if="actions?.length">
          <div class="flex gap-x-3">
            <button
              v-for="action in actions"
              :key="action.id"
              type="button"
              class="inline-flex items-center gap-x-2 rounded-lg border border-transparent text-sm font-semibold text-primary-700 hover:text-primary-900 focus:text-primary-900 focus:outline-none disabled:pointer-events-none disabled:opacity-50 dark:text-primary-500 dark:hover:text-primary-400 dark:focus:text-primary-400"
              @click="action.action"
            >
              {{ action.name }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'CalloutPanel',
  components: { FontAwesomeIcon },
  props: {
    title: {
      type: String,
      required: false,
      default: null
    },
    description: {
      type: String,
      required: false,
      default: null
    },
    icon: {
      type: Array,
      required: false,
      default: null
    },
    watermarkIcon: {
      type: Array,
      required: false,
      default: null
    },
    tint: {
      type: String,
      required: false,
      default: 'info'
    },
    primaryColor: {
      type: String,
      required: false,
      default: null
    },
    role: {
      type: String,
      required: false,
      default: 'alert'
    },
    actions: {
      type: Array,
      required: false,
      default: null
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    },
    inline: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped>
.callout-watermark-glow {
  filter: drop-shadow(0 0 6px var(--color-primary-200))
    drop-shadow(0 0 14px var(--color-primary-200));
}

:global(.dark) .callout-watermark-glow {
  filter: drop-shadow(0 0 6px var(--color-primary-700))
    drop-shadow(0 0 14px var(--color-primary-700));
}
</style>
